import apiClient from "./api-client";
import { FreelancerActivityReport } from "../models/FreelancerActivityReport";
import { ActivityReportsSummaryResponse } from "../models/ActivityReportsSummary";
import { FreelancerActivityReportSearchRequest } from "../models/requests/FreelancerActivityReportSearchRequest";
import { UpdateFreelancerActivityReportRequest } from "../models/requests/UpdateFreelancerActivityReportRequest";
import { BulkChangeFreelancerActivityReportStatusRequest } from "../models/requests/BulkChangeFreelancerActivityReportStatusRequest";

/**
 * Search for freelancer activity reports
 * POST /api/freelancer-activity-reports/search
 */
export const searchFreelancerActivityReports = async (
	request: FreelancerActivityReportSearchRequest,
	freelancerActivityReportKey: string = ""
): Promise<FreelancerActivityReport[]> => {
	const response = await apiClient.post<FreelancerActivityReport[]>(
		"/freelancer-activity-reports/search",
		request,
		{
			headers: {
				"Freelancer-Activity-Report-Key": freelancerActivityReportKey
			}
		}
	);
	return response.data;
};

/**
 * Update a freelancer activity report
 * PATCH /api/freelancer-activity-reports/{id}
 */
export const updateFreelancerActivityReport = async (
	id: number,
	request: UpdateFreelancerActivityReportRequest
): Promise<FreelancerActivityReport> => {
	const response = await apiClient.patch<FreelancerActivityReport>(
		`/freelancer-activity-reports/${id}`,
		request
	);
	return response.data;
};

/**
 * Bulk change status of freelancer activity reports
 * POST /api/freelancer-activity-reports/bulk-change-status
 */
export const bulkChangeFreelancerActivityReportStatus = async (
	requests: BulkChangeFreelancerActivityReportStatusRequest[]
): Promise<void> => {
	await apiClient.post("/freelancer-activity-reports/bulk-change-status", requests);
};

/**
 * Get activity reports summary for a project
 * GET /api/freelancer-activity-reports/summary/{projectId}
 */
export const getActivityReportsSummary = async (
	projectId: number
): Promise<ActivityReportsSummaryResponse> => {
	const response = await apiClient.get<ActivityReportsSummaryResponse>(
		`/freelancer-activity-reports/summary/${projectId}`
	);
	return response.data;
};
